/**
 * @file ProjectsPage.js
 * @description Manages the Projects page grid.
 * CHANGES:
 * - Removed tag limitation (now shows ALL tags)
 * - Improved tag wrapping for better visual flow
 */

export class ProjectsPage {
    constructor(services) {
        this.contentManager = services.content;
        this.stateManager = services.state;
        this.eventBus = services.eventBus;
        this.dom = {
            content: document.querySelector('#projects .content-block'),
        };
    }

    init() {
        this.render();
        this.addListeners();
    }

    render() {
        if (!this.dom.content) return;
        const projects = this.contentManager.getProjects();
        
        this.dom.content.innerHTML = `
            <h2 class="page-title">Project Manifests</h2>
            <div class="projects-grid">
                ${projects.map(project => `
                    <article class="project-card text-only" data-project-id="${project.id}">
                        <div class="project-card-header">
                            <div class="header-top">
                                <h3 class="project-title">${project.title}</h3>
                                <span class="project-status status-${project.status}">${project.status}</span>
                            </div>
                            <div class="project-meta">
                                <span class="meta-id">ID: ${project.id.substring(0, 8)}</span>
                            </div>
                        </div>
                        
                        <div class="project-card-body">
                            <p class="project-description">${project.excerpt}</p>
                        </div>
                        
                        <div class="project-card-footer">
                            <div class="project-tags">
                                ${project.tags.map(tag => `<span class="tag interactive" data-tag="${tag}">${tag}</span>`).join('')}
                            </div>
                            <span class="action-hint">_EXECUTE</span>
                        </div>
                    </article>
                `).join('')}
            </div>
        `;
    }

    addListeners() {
        if (!this.dom.content) return;
        
        this.dom.content.addEventListener('click', (e) => {
            // Handle Tag Clicks
            const tag = e.target.closest('.tag.interactive');
            if (tag) {
                e.stopPropagation();
                const skillName = tag.dataset.tag;
                this.eventBus.emit('modal:open:skill', { skillName });
                return;
            }

            // Handle Card Clicks (Navigation)
            const card = e.target.closest('.project-card');
            if (card) {
                const projectId = card.dataset.projectId;
                this.stateManager.navigate(['projects', projectId]);
            }
        });
    }
}